import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NewTanksService } from 'src/app/services/newTanks/newTanks.service';

@Component({
    selector: 'app-newTanks-card',
    templateUrl: './newTanks-card.component.html',
    styleUrls: ['./newTanks-card.component.scss'],
})
export class NewTanksCardComponent implements OnInit {

    newTanks$ = new BehaviorSubject<string | undefined>(undefined);

    constructor(
        private _newTanksService: NewTanksService
    ) {

    }

    ngOnInit() {
        this._newTanksService.getTankData$("0","7").subscribe(result => {
            this.newTanks$.next(result.scalar);
        });
    }
}
